import { api } from "@/lib/api";
import { Client, ClientDtoSchema, clientFromDto, clientToDto } from "@/models";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getClientQueryOptions, getClientsQueryOptions } from "./get.hooks";

export function useUpdateClient(opts?: {
  onSuccess?: (client: Client) => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: async (client: Client) => {
      const dto = clientToDto(client);
      const result = await api.put("/api/clients", dto, ClientDtoSchema);
      return clientFromDto(result);
    },
    onSuccess: (client) => {
      queryClient.setQueryData(getClientsQueryOptions.queryKey, (old) =>
        old?.map((c) => (c.id === client.id ? client : c)),
      );
      queryClient.setQueryData(
        getClientQueryOptions(client.id).queryKey,
        () => client,
      );
      toast({
        title: "toast.clientUpdated",
        variant: "success",
      });
      opts?.onSuccess?.(client);
    },
    onError: () => {
      toast({
        title: "toast.updateClientError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
